import api from "../services/api";

const path = "imagem";

export const getImages = async ({ Origem, limit }) => {
  let filter = Origem ? `?Origem=${Origem}` : "";
  filter += limit ? `&limit=${limit}` : "";
  return await api.get(`${path}${filter}`);
};

export const findImage = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editImage = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createImage = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteImage = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
